import { ApolloCache, Reference, StoreObject } from '@apollo/client'

export const evictFromCacheById = (cache: ApolloCache<any>, object: StoreObject | Reference) => {
  const normalizedId = cache.identify(object)
  cache.evict({ id: normalizedId })
  cache.gc()
}
